import { render } from "./base-info.vue?vue&type=template&id=0e40d380&scoped=true"
import script from "./base-info.vue?vue&type=script&lang=js"
export * from "./base-info.vue?vue&type=script&lang=js"

import "./base-info.vue?vue&type=style&index=0&id=0e40d380&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e40d380"]])

export default __exports__